export default __webpack_public_path__ + "src/assets/images/ReportsType_ExcelFile.xlsx";